const startPage: Record<string, Record<string, string> | string> = {
    logoAlt: 'ВНИИР',
};

export default startPage;
